import { render, staticRenderFns } from "./CursosProgramados.vue?vue&type=template&id=bf9d4322&scoped=true"
import script from "./CursosProgramados.vue?vue&type=script&lang=js"
export * from "./CursosProgramados.vue?vue&type=script&lang=js"
import style0 from "./CursosProgramados.vue?vue&type=style&index=0&id=bf9d4322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d4322",
  null
  
)

export default component.exports